module.exports = __webpack_public_path__ + "img/scrolledsecrets.b5da72b8.png";